import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/auth.service';
import { ToasterService } from '../../providers/toaster/toaster.service';

@Injectable({
  providedIn: 'root'
})
export class CouponService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private toasterService: ToasterService
  ) {}

  createCoupon(data: FormData | Record<string, unknown>): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        const isFormData = data instanceof FormData;
        const reqHeaders = isFormData
          ? headers.delete('Content-Type')
          : headers.set('Content-Type', 'application/json');

        return this.http.post(`${this.apiUrl}master/coupon/create`, data, {
          headers: reqHeaders,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error?.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  getAllCoupons(): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}master/coupon/get-all`, {
          headers,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error?.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  deleteCoupon(id: number | string): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}master/coupon/${id}/delete`, {
          headers,
          observe: 'response'
        });
      }),
      catchError((error) => {
        if (error?.status === 401) {
          this.handleTokenExpired();
        }
        return throwError(() => error);
      })
    );
  }

  private handleTokenExpired(): void {
    this.toasterService.setToaster('default', 'Session Expired', 'The session has expired. Please log in again.');
    this.authService.logout();
  }
}
